import pick from 'lodash-es/pick';
import { Ticket, TicketGroupInput } from 'src/WebApiController';

// Ticket delivery and sale related fields that should be preserved
// when ticket details are edited, or initialized as null for new tickets
const EmptyTicket: Partial<Ticket> = {
  qrCode: null,
  barcode: null,
  eTicket: null,
  ticketUrl: null,
  isWasted: null,
  externalTicketId: null,
  holdId: null,
  saleId: null,
};

export const toTicketKey = (ticket: Ticket) => `${ticket.row}-${ticket.seat}`;

export const sanitizeTicketGroups = (
  updatedTicketGroups: TicketGroupInput[],
  ticketLookup: Record<number, Record<string, Ticket>>
) => {
  return updatedTicketGroups.map((tg) => {
    const originalTicketsByKey = ticketLookup[tg.ticketGroupId] || {};
    if (!tg.tickets?.value) {
      return tg;
    }
    const sanitizedTickets = (tg.tickets?.value ?? []).map((ticket) => {
      const key = toTicketKey(ticket);
      const originalTicket = originalTicketsByKey[key];
      // If the ticket already exists, keep the delivery related fields
      if (originalTicket) {
        // all fields destructed are recalculated, keep the rest
        const originalDeliveryInfo = pick(
          originalTicket,
          Object.keys(EmptyTicket)
        );
        return { ...ticket, ...originalDeliveryInfo };
      }
      // For new ticket, populate delivery related fields with null and keep the rest of the fields
      return { ...ticket, ...EmptyTicket };
    });
    return {
      ...tg,
      tickets: { ...tg.tickets, value: sanitizedTickets },
    };
  });
};
